import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HrmsReportsRoutingModule } from './hrms-reports-routing.module';
import { HrmsLinkComponent } from './hrms-link/hrms-link.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { AllEnterpriseModule, LicenseManager, ModuleRegistry } from 'ag-grid-enterprise';
import { environment } from 'src/environments/environment';
import { AgGridModule } from 'ag-grid-angular';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HrmsHeaderComponent } from './hrms-header/hrms-header.component';
import { HrmsLandingPageComponent } from './hrms-landing-page/hrms-landing-page.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SubjectDetailsComponent } from './subject-details/subject-details.component';
import { DeptDesigDetailsComponent } from './dept-desig-details/dept-desig-details.component';
import { CostcentreDetailsComponent } from './costcentre-details/costcentre-details.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EmployeeExitDetailsComponent } from './employee-exit-details/employee-exit-details.component';


ModuleRegistry.registerModules([AllEnterpriseModule]);
LicenseManager.setLicenseKey(environment.ag_grid_key);


@NgModule({
  declarations: [
    HrmsLinkComponent,
    HrmsHeaderComponent,
    HrmsLandingPageComponent,
    SidebarComponent,
    SubjectDetailsComponent,
    DeptDesigDetailsComponent,
    CostcentreDetailsComponent,
    EmployeeExitDetailsComponent
  ],
  imports: [
    CommonModule,
    HrmsReportsRoutingModule,
    AcademicFormModule,
    AgGridModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
     MatTooltipModule,
  ]
})
export class HrmsReportsModule { }
